<template>
    <div v-if="showStep" class="step-card-wrapper">
        <generic-step-card
            :title="stepTitle"
            :current-step-name="currentStepName"
            :step="step"
            :is-preview="isPreview"
            :brief-accepted="isBriefAccepted"
            :is-brief-editable="isBriefEditable"
            :brief="brief"
        >
            <div v-if="briefFields" slot="details" :class="classes">
                <div v-for="field in briefFields" :key="field.field_id">
                    <g-typography :value="getInfoText(field)" :color="currentStepHighlighted ? 'white' : 'body'" />
                </div>
            </div>
        </generic-step-card>
    </div>
</template>

<script>
    import GenericStepCard from '../GenericStepCard.vue';
    import { NAME_PERSONAL_INFO } from '../../../../../constants/activation-brief-steps';
    import StepCardViewMixin from '../mixins/StepCardViewMixin';
    import { get } from 'lodash';

    export default {
        name: 'PersonalInfoStepCardView',
        components: {
            GenericStepCard
        },
        mixins: [StepCardViewMixin],
        props: {
            briefFields: {
                type: Array
            }
        },
        computed: {
            stepName() {
                return NAME_PERSONAL_INFO;
            },
            classes() {
                return {
                    'left-indent': this.isBriefEditable
                };
            },
            currentStepHighlighted() {
                return this.currentStepName === NAME_PERSONAL_INFO;
            }
        },
        methods: {
            getInfoText(field) {
                const label = get(field, 'field.external_label', false) || get(field, 'field.label', '');
                const input = get(field, 'field.value') ?? '?';
                return `${label}: ${input}`;
            }
        }
    };
</script>

<style lang="scss" scoped>
    .step-card-wrapper {
        margin-bottom: $g-spacing-5;
    }
    .left-indent {
        margin-left: $g-spacing-7;
    }
</style>
